<script lang="ts">
  import { Pagination } from 'carbon-components-svelte';
  import { onMount, createEventDispatcher } from 'svelte';

  export let page: number, pageSize: number, pageSizes: number[], totalItems: number;

  const dispatch = createEventDispatcher<{
    init: never;
    change: { page: number; pageSize: number };
  }>();

  const handlePopstate = () => {
    const url = new URL(window.location.href);
    const currentUrlPage = parseInt(url.searchParams.get('page') || '', 10);
    const currentUrlPageSize = parseInt(url.searchParams.get('pageSize') || '', 10);

    page = currentUrlPage || page;
    pageSize = currentUrlPageSize || pageSize;

    if (!currentUrlPage || !currentUrlPageSize) {
      synchronizePagination(false);
    }
  };

  const handleUpdate = (event: CustomEvent<{ page: number; pageSize: number }>) => {
    page = event.detail.page;
    pageSize = event.detail.pageSize;
  };

  const synchronizePagination = (isInitial: boolean) => {
    const url = new URL(window.location.href);
    const currentUrlPage = parseInt(url.searchParams.get('page') || '', 10);
    const currentUrlPageSize = parseInt(url.searchParams.get('pageSize') || '', 10);

    if (isInitial) {
      page = currentUrlPage || page;
      pageSize = currentUrlPageSize || pageSize;
      return;
    }

    if (currentUrlPage !== page || currentUrlPageSize !== pageSize) {
      url.searchParams.set('page', page.toString());
      url.searchParams.set('pageSize', pageSize.toString());

      if (!currentUrlPage || !currentUrlPageSize) {
        window.history.replaceState({}, '', url);
      } else {
        window.history.pushState({}, '', url);
      }

      dispatch('change', { page, pageSize });
    }
  };

  synchronizePagination(true);

  onMount(() => dispatch('init'));

  // eslint-disable-next-line @typescript-eslint/no-unused-expressions
  $: page, pageSize, totalItems, synchronizePagination(false);
</script>

<svelte:window on:popstate={handlePopstate} />

{#if totalItems > 0}
  <Pagination {page} {pageSize} {pageSizes} {totalItems} on:update={handleUpdate} />
{/if}
